import { render, staticRenderFns } from "./applyHcgSettItem.vue?vue&type=template&id=2b49c234&scoped=true&"
import script from "./applyHcgSettItem.vue?vue&type=script&lang=js&"
export * from "./applyHcgSettItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49c234",
  null
  
)

export default component.exports